module.exports = __webpack_public_path__ + "static/img/brochure_lumiere2.d913a1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/brochure_lumiere2.jpg
// module id = 25
// module chunks = 0